// ConfirmationModal.js
// This is the confirmation modal component for the sampling event form

// Confirmation Modal Component
export const ConfirmationModal = ({
  onCancel,
  onConfirm,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  styles = {
    confirmationModalOverlay: "confirmationModalOverlay",
    confirmationModalContent: "confirmationModalContent",
    confirmationModalHeader: "confirmationModalHeader",
    confirmationModalMessage: "confirmationModalMessage",
    confirmationModalButtons: "confirmationModalButtons",
    confirmCancel: "confirmCancel",
    confirmButton: "confirmButton",
  },
  confirmButtonClass = "confirmButton",
}) => {
  return (
    <div className={styles.confirmationModalOverlay}>
      <div className={styles.confirmationModalContent}>
        <h2 className={styles.confirmationModalHeader}>{title}</h2>
        <p className={styles.confirmationModalMessage}>{message}</p>
        <div className={styles.confirmationModalButtons}>
          <button className={styles.confirmCancel} onClick={onCancel}>
            {cancelText}
          </button>
          <button className={styles[confirmButtonClass]} onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};
